import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

/** Rotta `''`: reindirizza senza attivare il componente (evita navigate + return false e redirect multipli). */
export const authGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  if (authenticationService.isLoggedIn) {
    return router.createUrlTree(['/home']);
  }
  return router.createUrlTree(['/login']);
};
